module.exports = __webpack_public_path__ + "static/img/Adam_Treloar_mobile.448e2a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam_Treloar_mobile.jpg
// module id = z1UT
// module chunks = 0